 import {
  Button,
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { URL } from "../../api";
import axiosInstance from "../../Request";
// forceSuccess (payment view): every account row reads as Success and the
// card header always shows "Done" — penny drop is treated as passed for
// payment-transaction customers.
const PennyDropCard = ({ cid, penny_drop_data, forceSuccess = false }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [comment, setComment] = useState("");
  const [statusText, setStatusText] = useState("Pending");

  useEffect(() => {
    setStatusText(forceSuccess || penny_drop_data ? "Done" : "Pending");
  }, [penny_drop_data, forceSuccess]);

  const fetchData = async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.get(`${URL.PENNY_DROP_STATUS}?customer_id=${cid}`);
    const data = response.data;
    setAccountData(data);
  } catch (error) {
    console.error("Error fetching account details:", error);
  }
  setLoading(false);
};

  const toggleModal = async () => {
    if (!modalOpen) {
      await fetchData();
    }
    setModalOpen(!modalOpen);
  };
  

  const openCommentModal = (accountId) => {
    setSelectedAccountId(accountId);
    setComment("");
    setCommentModalOpen(true);
  };

  const handleSubmitComment = async () => {
    const userId = localStorage.getItem("user_id");
    if (!comment.trim() || !selectedAccountId) return;

    setLoading(true);
    try {
  await axiosInstance.get(
    `${URL.PENNY_DROP_COMMENT}?customer_id=${cid}&user_id=${userId}&comment=${encodeURIComponent(comment)}&account_id=${selectedAccountId}`
  );

  const updated = await axiosInstance.get(`${URL.PENNY_DROP_STATUS}?customer_id=${cid}`);
  const updatedData = updated.data;
  const updatedRow = updatedData.find((item) => item.accountId === selectedAccountId);

  setAccountData((prev) =>
    prev.map((item) => (item.accountId === selectedAccountId ? updatedRow : item))
  );
} catch (error) {
  console.error("Error processing penny drop:", error);
}

setLoading(false);
setCommentModalOpen(false);
  };

  const handleSetDefault = async (accountId) => {
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      alert("User ID not found.");
      return;
    }

    setLoading(true);
    try {
  await axiosInstance.post(
    `${URL.PENNY_IS_DEFAULT}?customer_id=${cid}&user_id=${userId}&account_id=${accountId}`
  );
  await fetchData();
} catch (error) {
  console.error("Error setting default account:", error);
} finally {
  setLoading(false);
}
  };

  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Penny Drop
                </CardTitle>
                <span
                  className={`h2 font-weight-bold mb-0 clickable ${statusText === "Done" ? "text-success" : "text-danger"}`}
                  onClick={toggleModal}
                  style={{ cursor: "pointer" }}
                >
                  {loading ? "Loading..." : statusText}
                </span>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Bank Details</ModalHeader>
        <ModalBody style={{ overflowX: "auto" }}>
          {loading ? (
            <span>Loading...</span>
          ) : Array.isArray(accountData) && accountData.length > 0 ? (
            <table className="table table-bordered table-hover" style={{ minWidth: "800px" }}>
              <thead>
                <tr>
                  <th>Account Number</th>
                  <th>Bank Name</th>
                  <th>IFSC</th>
                  <th>Name</th>
                  <th>Match Score</th>
                  <th>Status</th>
                  <th>Reason</th>
                  <th>Actions</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                {accountData.map((acc, index) => (
                  <tr key={index} style={{ backgroundColor: acc.isDefault === 1 ? "#cce5ff" : "inherit" }}>
                    <td>{acc.accountNumber}</td>
                    <td>{acc.bankName || "-"}</td>
                    <td>{acc.ifscCode || "-"}</td>
                    <td>{acc.customerName || "-"}</td>
                    <td>{acc.matchScore !== null ? `${acc.matchScore}%` : "-"}</td>
                    <td>
                      {forceSuccess || acc.pennyStatus === 1
                        ? "Success"
                        : acc.pennyStatus === 2
                        ? "Failed"
                        : "Pending"}
                    </td>
                    <td>{!forceSuccess && acc.pennyStatus === 2 ? acc.reason || "No reason provided" : "-"}</td>
                    <td>
                      {!forceSuccess && acc.pennyStatus !== 1 && (
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => openCommentModal(acc.accountId)}
                          disabled={loading}
                        >
                          Refresh
                        </Button>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Input
                        type="radio"
                        name="defaultAccount"
                        checked={acc.isDefault === 1}
                        onChange={() => handleSetDefault(acc.accountId)}
                        disabled={loading}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No account details found.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Comment Modal */}
      <Modal isOpen={commentModalOpen} toggle={() => setCommentModalOpen(false)}>
        <ModalHeader toggle={() => setCommentModalOpen(false)}>Add Comment</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="comment">Comment</Label>
            <Input
              type="textarea"
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your comment here..."
              required
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmitComment} disabled={!comment.trim() || loading}>
            Submit
          </Button>
          <Button color="secondary" onClick={() => setCommentModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PennyDropCard;
